// Punjabi (India) [pa-in]
import dayjs from '../index';
var locale = {
  name: 'pa-in',
  weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
  months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
  weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
  monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
  weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
  ordinal: function ordinal(n) {
    return n;
  },
  formats: {
    LT: 'A h:mm ਵਜੇ',
    LTS: 'A h:mm:ss ਵਜੇ',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
    LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
  },
  relativeTime: {
    future: '%s ਵਿੱਚ',
    past: '%s ਪਿਛਲੇ',
    s: 'ਕੁਝ ਸਕਿੰਟ',
    m: 'ਇਕ ਮਿੰਟ',
    mm: '%d ਮਿੰਟ',
    h: 'ਇੱਕ ਘੰਟਾ',
    hh: '%d ਘੰਟੇ',
    d: 'ਇੱਕ ਦਿਨ',
    dd: '%d ਦਿਨ',
    M: 'ਇੱਕ ਮਹੀਨਾ',
    MM: '%d ਮਹੀਨੇ',
    y: 'ਇੱਕ ਸਾਲ',
    yy: '%d ਸਾਲ'
  }
};
dayjs.locale(locale, null, true);
export default locale;